'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _information = require('./information.component');

var _information2 = _interopRequireDefault(_information);

var _productLabelDownload = require('./product-label-download/product-label-download.module');

var _productLabelDownload2 = _interopRequireDefault(_productLabelDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.information', [_productLabelDownload2.default]).component('information', _information2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/information/information.module.js